import { erpApi } from "@/shared/axios";
import { urlBackend } from "@/shared/constants";

const { get } = erpApi();

const CAMPANAS_BASE_URL = `${urlBackend}api/v1/campanas`;

export type TraceabilityModuleType = "MIGRATION" | "FIDELIZATION";
export type TraceabilityDataSourceType = "CSV" | "INTERNAL_SEARCH";
export type TraceabilityAction = "SEARCH" | "CREATE_TICKETS" | "SEND_EMAIL";
export type TraceabilityStatus = "SUCCESS" | "WARNING" | "ERROR";

export interface TraceabilityFilters {
  module?: TraceabilityModuleType;
  dataSource?: TraceabilityDataSourceType;
  action?: TraceabilityAction;
  status?: TraceabilityStatus;
  desde?: string;
  hasta?: string;
  page?: number;
  size?: number;
}

export interface CampaignTraceabilityResponse {
  id: number;
  module: TraceabilityModuleType;
  dataSource: TraceabilityDataSourceType | null;
  action: TraceabilityAction;
  status: TraceabilityStatus;
  userId: number | null;
  username: string | null;
  filtersJson: string | null;
  requestPayloadJson: string | null;
  responseSummaryJson: string | null;
  totalFound: number | null;
  candidatesSaved: number | null;
  selectedCandidates: string | null;
  ticketsCreated: number | null;
  ticketsFailed: number | null;
  emailRecipients: string | null;
  message: string | null;
  createdAt: string;
  customers?: TraceabilityCustomerResponse[] | null;
}

export interface TraceabilityCustomerResponse {
  candidateId?: number | string | null;
  identification?: string | null;
  razonSocial?: string | null;
  customerName?: string | null;
  ticketsCustomerId?: string | null;
  ticketsContractId?: string | null;
  ticketsContractEquipmentId?: string | null;
  module?: TraceabilityModuleType | null;
}

export interface CampaignTraceabilityPageResponse<T> {
  content: T[];
  totalElements: number;
  totalPages: number;
  size: number;
  number: number;
}

export const getCampaignTraceability = async (
  filters: TraceabilityFilters,
): Promise<CampaignTraceabilityPageResponse<CampaignTraceabilityResponse>> => {
  const params = new URLSearchParams();

  if (filters.module) params.append("module", filters.module);
  if (filters.dataSource) params.append("dataSource", filters.dataSource);
  if (filters.action) params.append("action", filters.action);
  if (filters.status) params.append("status", filters.status);
  if (filters.desde) params.append("desde", filters.desde);
  if (filters.hasta) params.append("hasta", filters.hasta);

  params.append("page", String(filters.page ?? 0));
  params.append("size", String(filters.size ?? 10));

  const response = await get<
    CampaignTraceabilityPageResponse<CampaignTraceabilityResponse>
  >(`${CAMPANAS_BASE_URL}/traceability?${params.toString()}`, true);

  return ((response as any)?.data ??
    response) as CampaignTraceabilityPageResponse<CampaignTraceabilityResponse>;
};
